'use strict';

var Params = function Params(data, forceWidth) {
  return function (containerWidth) {
    var padding = {
      top: 10,
      bottom: 55,
      left: 75,
      right: 90
    };
    var barWidth = 40;
    var width = containerWidth - (padding.left + padding.right);
    if (forceWidth) {
      width = barWidth * data.length;
      containerWidth = width + padding.left + padding.right;
    }
    var height = 200;
    return {
      width: width,
      height: height,
      containerWidth: containerWidth,
      containerHeight: height + padding.top + padding.bottom,
      padding: padding,
      yNumberOfTicks: 8,
      yAxisShift: 12,
      yAxisLabelShift: 55,
      forceHeight: true,
      forceWidth: forceWidth
    };
  };
};
module.exports = Params;